export enum ReportLayout {
  // In the various split modes, toggle will be shown to switch between the split modes
  SplitChartOnly = `split_chart_only`,
  SplitChartTable = `split_chart_table`,
  SplitTableOnly = `split_table_only`,
  SplitChartAnnotations = `split_chart_annotations`,
  // In non-split mode, toggle won't be shown
  NonSplit = `non_split`,
}
